<div *ngIf="currentEnv == 'emvs'">
  <div class="page__content">
    <div class="content__inner">
      <div class="register-form">
        <div class="row">
          <div class="col-sm-12">
            <h5 id="solicitud-titulo">{{procedimiento.nombre}}
            </h5>
          </div>
        </div>

        <ul class="nav nav-tabs nav-stepper" id="myTab" role="tablist">
          <li class="nav-item">
            <a [ngClass]="esNavegable('personales-tab')" class="active" id="personales-tab" data-toggle="tab"
              href="#personales" role="tab" aria-controls="home" aria-selected="true"
              (click)="restauraPestaniaSeleccionada('personales-tab')">
              <span>{{ 'TRAMITE.TABS.APPLICANT_DATA' | translate }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a [ngClass]="esNavegable('circunstancias-tab')" id="circunstancias-tab" data-toggle="tab"
              href="#circunstancias" role="tab" aria-controls="profile"
              (click)="restauraPestaniaSeleccionada('circunstancias-tab')">{{ 'TRAMITE.TABS.ECONOMIC_CIRCUMSTANCES' | translate }}</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="esNavegable('unidad-tab')" id="unidad-tab" data-toggle="tab" href="#unidad" role="tab"
              aria-controls="contact" (click)="restauraPestaniaSeleccionada('unidad-tab')">{{ 'TRAMITE.TABS.FAMILY_UNIT' | translate }}</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="esNavegable('distritos-tab')" id="distritos-tab" data-toggle="tab" href="#distritos"
              role="tab" aria-controls="contact" aria-selected="false"
              (click)="restauraPestaniaSeleccionada('distritos-tab')">{{ 'TRAMITE.TABS.MUNICIPAL_DISTRICTS' | translate }}</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="esNavegable('vulnerabilidad-tab')" id="vulnerabilidad-tab" data-toggle="tab"
              href="#vulnerabilidad" role="tab" aria-controls="contact" aria-selected="false"
              (click)="restauraPestaniaSeleccionada('vulnerabilidad-tab')">{{ 'TRAMITE.TABS.VULNERABILITY' | translate }}</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="esNavegable('consulta-tab')" id="consulta-tab" data-toggle="tab" href="#consulta" role="tab"
              aria-controls="contact" aria-selected="false"
              (click)="restauraPestaniaSeleccionada('consulta-tab')">{{ 'TRAMITE.TABS.RESPONSIBLE_DECLARATION' | translate }}</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="esNavegable('autorizacion-tab')" id="autorizacion-tab" data-toggle="tab" href="#autorizacion"
              role="tab" aria-controls="contact" aria-selected="false"
              (click)="restauraPestaniaSeleccionada('autorizacion-tab')">{{ 'TRAMITE.TABS.DATA_AUTHORIZATION' | translate }}</a>
          </li>
        </ul>
        <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate" [fullScreen] = "true" [name]="'tramite_rpsv_spinner'">
          <p style="color: white" >{{mensajeSpinner}}</p>
        </ngx-spinner>
        <div class="tab-content" id="myTabContent">

          <div class="tab-pane fade show active" id="personales" role="tabpanel" aria-labelledby="personales-tab">


            <div>

              <h3 class="tabtitle">{{ 'TRAMITE.TITLES.PERSONAL_DATA_NOTIFICATIONS' | translate }}</h3>
              <div class="row mt-3">
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.N_DE_DOCUMENTO' | translate }}</label>
                  <input type="text" id="numero_documento" name="numero_documento"
                    [ngModel]="this.currentUser.numero_documento" class="form-control" disabled />
                </div>
                <div class="col-sm-4 spacing-box" *ngIf="this.currentUser.tipopersona.id == 1">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.APELLIDOS' | translate }}</label>
                  <input type="text" id="apellido" name="apellido"
                    [ngModel]="this.currentUser.apellido1 + ' ' +this.currentUser.apellido2" class="form-control"
                    disabled>
                </div>
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ (this.currentUser.tipopersona.id == 1 ? 'TRAMITE.FORM.LABEL.NOMBRE' : 'TRAMITE.FORM.LABEL.RAZON_SOCIAL') | translate }}</label>
                  <input type="text" id="nombre" name="nombre" [ngModel]="this.currentUser.nombre" class="form-control"
                    disabled />
                </div>
                <div class="col-sm-2 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_VIA' | translate }}</label>
                  <input type="text" id="tipovia" name="tipovia" [ngModel]="this.activeAddress.type_of_road.tipovia"
                    class="form-control" disabled>
                </div>
                <div class="col-sm-8 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.DIRECCION' | translate }}</label>
                  <input type="text" id="name_road" name="name_road"
                    [ngModel]="this.activeAddress.name_road + ' ' + this.activeAddress.number_road" class="form-control"
                    disabled>
                </div>

                <div *ngIf="activeAddress.block" class="col-sm-2 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PORTAL' | translate }}</label>
                  <input type="text" id="block" name="block" [ngModel]="this.activeAddress.block" class="form-control"
                    disabled>
                </div>

                <div *ngIf="activeAddress.stairs" class="col-sm-2 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.ESCALERA' | translate }}</label>
                  <input type="text" id="stairs" name="stairs" [ngModel]="this.activeAddress.stairs"
                    class="form-control" disabled>
                </div>

                <div *ngIf="activeAddress.floor" class="col-sm-2 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PLANTA' | translate }}</label>
                  <input type="text" id="floor" name="floor" [ngModel]="this.activeAddress.floor" class="form-control"
                    disabled>
                </div>

                <div *ngIf="activeAddress.door" class="col-sm-2 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PUERTA' | translate }}</label>
                  <input type="text" id="door" name="door" [ngModel]="this.activeAddress.door" class="form-control"
                    disabled>
                </div>
                <div class="col-sm-2 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CODIGO_POSTAL' | translate }}</label>
                  <input type="text" id="postal_code" name="postal_code" [ngModel]="this.activeAddress.postal_code"
                    class="form-control" disabled />
                </div>
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PROVINCIA' | translate }}</label>
                  <input class="w-100 form-control" id="province" name="province"
                    [ngModel]="activeAddress.province.nombre" disabled />
                </div>
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.MUNICIPIO' | translate }}</label>
                  <input class="w-100 form-control" id="nameMunicipality" name="nameMunicipality"
                    [ngModel]="municipioNombre" disabled />
                </div>
                <div class="col-sm-4 spacing-box">
                  <div class="form-group">
                    <label class="tinyLabel">{{ 'PLACEHOLDER.EMAIL' | translate }}</label>
                    <input type="text" id="email" name="email" [ngModel]="this.currentUser.email" class="form-control"
                      disabled />
                  </div>
                </div>
                <div class="col-sm-4 spacing-box">
                  <div class="form-group">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO_1' | translate }}</label>
                    <input type="text" id="telefono" name="telefono" [ngModel]="this.currentUser.telefono"
                      class="form-control" disabled />
                  </div>
                </div>
                <div class="w-100 mlr-14px">
                  <form [formGroup]="formTramite" (ngSubmit)="onSubmitTramite()" class=" row">
                    <div class="col-sm-4 spacing-box">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO_2' | translate }}</label>
                      <input type="text" id="telefono2" name="telefono2"
                        [ngClass]="{'is-invalid': submitted && this.formTramite.controls['telefono2'].errors}"
                        class="form-control" formControlName="telefono2" />
                      <mat-error *ngIf="this.formTramite.get('telefono2')?.hasError('pattern')">{{ 'TRAMITE.ERROR.PHONE_FORMAT' | translate }}
                        no es correcto</mat-error>
                    </div>
                    <div class="col-sm-4 spacing-box">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO_3' | translate }}</label>
                      <input type="text" id="telefono3" name="telefono3"
                        [ngClass]="{'is-invalid': submitted && this.formTramite.controls['telefono3'].errors}"
                        class="form-control" formControlName="telefono3" />
                      <mat-error *ngIf="this.formTramite.get('telefono3')?.hasError('pattern')">{{ 'TRAMITE.ERROR.PHONE_FORMAT' | translate }}
                        no es correcto</mat-error>
                    </div>
                    <div class="col-sm-4 spacing-box" *ngIf="this.currentUser.tipopersona.id == 1">
                      <div class="spacing-box">
                        <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                          <label>{{ 'TRAMITE.FORM.LABEL.GENERO' | translate }}</label>
                          <div class="form-check form-check-inline">
                            <input [ngClass]="{'checkDisabled': currentUser.genero != null}"
                              class="form-check-input radio-personalice" type="radio" formControlName="genero"
                              name="genero" id="inlineRadio1" value="Hombre">
                            <label class="form-check-label" for="inlineRadio1"
                              [ngClass]="{'invalid-file': submitted && formTramite.controls['genero'].errors}">{{ 'TRAMITE.FORM.LABEL.HOMBRE' | translate }}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input [ngClass]="{'checkDisabled': currentUser.genero != null}"
                              class="form-check-input radio-personalice" type="radio" formControlName="genero"
                              name="genero" id="inlineRadio2" value="Mujer">
                            <label class="form-check-label" for="inlineRadio2"
                              [ngClass]="{'invalid-file': submitted && formTramite.controls['genero'].errors}">{{ 'TRAMITE.FORM.LABEL.MUJER' | translate }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-100 spacing-box gap-2 d-md-flex justify-content-md-end btn-form-pad">
                      <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                      <button type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>
                      <button type="submit" class="btn btn-primary mt-2" id="siguiente2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>





          <div class="tab-pane fade" id="circunstancias" role="tabpanel" aria-labelledby="circunstancias-tab">
            <form [formGroup]="formCircunstancias" (ngSubmit)="onSubmitCircunstancias()">
              <h3 class="tabtitle">{{ 'TRAMITE.TITLES.ECONOMIC_FAMILY_PERSONAL' | translate }}</h3>
              <div class="row mt-3">
                <div class="col-sm-12">
                  <span class="manual-help activo"><a class="icons-tramite"
                      href="https://www.emvs.es/Vivienda/RPSV/Documents/Instrucciones de inscripción en el RPSV a través de la Oficina Virtual.pdf"
                      target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                        title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.ACREDITA_RESIDENCIA_EN_EL_MUNICIPIO_DE_MADRID_DE_AL_MENOS_1_ANO_ININTERRUMPIDO_C' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1"
                        name="pregunta1" id="inlineRadioPregunta1si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta1si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1"
                        name="pregunta1" id="inlineRadioPregunta1no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta1no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.EN_CASO_DE_NO_ACREDITAR_EMPADRONAMIENTO_DESARROLLA_SU_ACTIVIDAD_LABORAL_EN_EL_MU' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2"
                        name="pregunta2" id="inlineRadioPregunta2si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta2si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2"
                        name="pregunta2" id="inlineRadioPregunta2no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta2no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.USTED_O_ALGUN_MIEMBRO_DE_SU_UNIDAD_FAMILIAR_TIENE_UNA_DISCAPACIDAD_CON_MOVILIDAD' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta3"
                        name="pregunta3" id="inlineRadioPregunta3si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta3si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta3"
                        name="pregunta3" id="inlineRadioPregunta3no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta3no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.SI_LA_PREGUNTA_ANTERIOR_ES_AFIRMATIVA_Y_SU_UNIDAD_FAMILIAR_ES_DE_UNA_PERSONA_TIE' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4"
                        name="pregunta4" id="inlineRadioPregunta4si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta4si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4"
                        name="pregunta4" id="inlineRadioPregunta4no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta4no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.TIENE_USTED_TITULO_DE_FAMILIA_NUMEROSA_EN_VIGOR' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta5"
                        name="pregunta5" id="inlineRadioPregunta5si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta5si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta5"
                        name="pregunta5" id="inlineRadioPregunta5no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta5no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.ES_USTED_UNA_FAMILIA_MONOPARENTAL' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta6"
                        name="pregunta6" id="inlineRadioPregunta6si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta6si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta6"
                        name="pregunta6" id="inlineRadioPregunta6no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta6no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.TIENE_USTED_VIVIENDA_EN_PROPIEDAD_INDEPENDIENTEMENTE_DEL_TITULO_O_PORCENTAJE_SOB' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta7"
                        name="pregunta7" id="inlineRadioPregunta7si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta7si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta7"
                        name="pregunta7" id="inlineRadioPregunta7no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta7no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.ES_USTED_ARRENDATARIO_A_DE_UNA_VIVIENDA_EN_PROPIEDAD_O_GESTIONADA_POR_EMVS_MADRI' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta8"
                        name="pregunta8" id="inlineRadioPregunta8si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta8si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta8"
                        name="pregunta8" id="inlineRadioPregunta8no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta8no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.ES_USTED_VICTIMA_DIRECTA_O_INDIRECTA_DE_VIOLENCIA_DE_GENERO_TRATA_Y_O_EXPLOTACIO' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta9"
                        name="pregunta9" id="inlineRadioPregunta9si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta9si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta9"
                        name="pregunta9" id="inlineRadioPregunta9no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta9no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.ACREDITA_CONDICION_DE_REFUGIADO_A' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta10"
                        name="pregunta10" id="inlineRadioPregunta10si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta10si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta10"
                        name="pregunta10" id="inlineRadioPregunta10no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta10no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.SE_ENCUENTRA_ACTUALMENTE_OCUPANDO_UNA_VIVIENDA_INMUEBLE_DE_EMVS_MADRID_O_DEL_AYU' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta11"
                        name="pregunta11" id="inlineRadioPregunta11si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta11si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta11"
                        name="pregunta11" id="inlineRadioPregunta11no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta11no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.HA_SIDO_LANZADO_JUDICIALMENTE_POR_OCUPACION_DE_UNA_VIVIENDA_DE_TITULARIDAD_O_GES' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta12"
                        name="pregunta12" id="inlineRadioPregunta12si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta12si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta12"
                        name="pregunta12" id="inlineRadioPregunta12no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta12no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>
                    <button type="submit" class="btn btn-primary m-right mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="unidad" role="tabpanel" aria-labelledby="unidad-tab">
            <form [formGroup]="formUnidadFamiliar" (ngSubmit)="onSubmitUnidadFamiliar()">
              <h3 class="tabtitle">{{ 'TRAMITE.TITLES.FAMILY_UNIT_DATA' | translate }}</h3>
              <div class="row mt-3">
                <div class="col-sm-12">
                  <span class="manual-help activo"><a class="icons-tramite"
                      href="https://www.emvs.es/Vivienda/RPSV/Documents/Instrucciones de inscripción en el RPSV a través de la Oficina Virtual.pdf"
                      target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                        title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                </div>
              </div>
              <div formArrayName="familiar">
                <div class="familiar-accordion">
                  <div class="familiar-card" *ngFor="let passengerGroup of familiar?.controls; let i = index"
                    [class.is-active]="familiarActivo === i"
                    [class.has-errors]="submitFamiliar && familiar.controls[i].invalid" [formGroupName]="i">
                    <button type="button" class="familiar-card__header" (click)="toggleFamiliar(i)"
                      [attr.aria-expanded]="familiarActivo === i">
                      <span class="familiar-card__index">{{ i + 1 }}</span>
                      <span class="familiar-card__summary">
                        <strong>{{ passengerGroup.get('nombre')?.value || passengerGroup.get('primerApellido')?.value
                          ? (passengerGroup.get('nombre')?.value + ' ' + (passengerGroup.get('primerApellido')?.value ||
                          '')).trim()
                          : 'Familiar sin completar' }}</strong>
                        <small>
                          <ng-container *ngIf="passengerGroup.get('parentesco')?.value">{{
                            passengerGroup.get('parentesco')?.value }}</ng-container>
                          <ng-container
                            *ngIf="passengerGroup.get('parentesco')?.value && passengerGroup.get('documento')?.value"> ·
                          </ng-container>
                          <ng-container *ngIf="passengerGroup.get('documento')?.value">{{
                            passengerGroup.get('documento')?.value }}</ng-container>
                        </small>
                      </span>
                      <span class="familiar-card__chevron" aria-hidden="true">▾</span>
                    </button>
                    <div class="familiar-card__body" *ngIf="familiarActivo === i">
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.DNI_NIE' | translate }}</label>
                        <input type="text"
                          [readonly]="i == 0 && passengerGroup.get('documento')?.value == this.numerodocumento && passengerGroup.get('documento')?.value ? 'true' : null"
                          formControlName="documento" class="form-control"
                          [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('documento').errors}">
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'PROCEDIMIENTO.EDIT.NAME' | translate }}</label>
                        <input type="text"
                          [readonly]="i == 0 && passengerGroup.get('documento')?.value == this.numerodocumento && passengerGroup.get('nombre')?.value ? 'true' : null"
                          formControlName="nombre" class="form-control"
                          [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('nombre').errors}">
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.APELLIDO_1' | translate }}</label>
                        <input type="text"
                          [readonly]="i == 0 && passengerGroup.get('documento')?.value == this.numerodocumento && passengerGroup.get('primerApellido')?.value ? 'true' : null"
                          formControlName="primerApellido" class="form-control"
                          [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('primerApellido').errors}">
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.APELLIDO_2' | translate }}</label>
                        <input type="text"
                          [readonly]="i == 0 && passengerGroup.get('documento')?.value == this.numerodocumento && passengerGroup.get('segundoApellido')?.value ? 'true' : null"
                          formControlName="segundoApellido" class="form-control"
                          [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('segundoApellido').errors}">
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.FECHA_DE_NACIMIENTO' | translate }}</label>
                        <input type="date" formControlName="fecha_nacimiento" class="form-control"
                          [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('fecha_nacimiento').errors}">
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.PARENTESCO' | translate }}</label>
                        <mat-select formControlName="parentesco" class="form-control"
                          [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('parentesco').errors, 'readonly-wrapper': i == 0 && passengerGroup.get('documento')?.value == this.numerodocumento && passengerGroup.get('parentesco')?.value}">
                          <ng-container *ngFor="let parentesco of parentescos">
                            <mat-option
                              *ngIf="(i == 0 && passengerGroup.get('documento')?.value == this.numerodocumento && parentesco == 'SOLICITANTE') || (i != 0 && parentesco != 'SOLICITANTE')"
                              [value]="parentesco">{{ parentesco }}</mat-option>
                          </ng-container>
                        </mat-select>
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.ESTADO_CIVIL' | translate }}</label>
                        <mat-select formControlName="estado_civil" class="form-control"
                          [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('estado_civil').errors}">
                          <mat-option *ngFor="let estado of estadosCiviles" [value]="estado.id">{{ estado.nombre
                            }}</mat-option>
                        </mat-select>
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.GRADO_DE_DISCAPACIDAD' | translate }}</label>
                        <mat-select formControlName="grado_discapacidad" class="form-control"
                          [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('grado_discapacidad').errors}">
                          <mat-option *ngFor="let grado of gradosDiscapacidad" [value]="grado.id">{{ grado.nombre
                            }}</mat-option>
                        </mat-select>
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.GRADO_DE_DEPENDENCIA' | translate }}</label>
                        <mat-select formControlName="grado_dependencia" class="form-control"
                          [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('grado_dependencia').errors}">
                          <mat-option *ngFor="let grado of gradosDependencia" [value]="grado.id">{{ grado.nombre
                            }}</mat-option>
                        </mat-select>
                      </div>
                      <div class="familiar-field familiar-field--actions" *ngIf="i > 0">
                        <button type="button" (click)="deleteFamiliar(i)" class="btn btn-danger">{{ 'TRAMITE.FAMILY.DELETE' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-sm-12 pt-2">
                <div class="form-group">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" (click)="addFamiliar()" class="btn btn-primary">{{ 'TRAMITE.CONTENT.ANADIR_FAMILIAR' | translate }}</button>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 pt-2">
                <div class="form-group">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>
                    <button type="submit" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="distritos" role="tabpanel" aria-labelledby="distritos-tab">
            <form [formGroup]="formDistritos" (ngSubmit)="onSubmitDistritos()">
              <h3 class="tabtitle">{{ 'TRAMITE.TITLES.MUNICIPAL_DISTRICTS' | translate }}</h3>
              <div class="row">
                <div class="col-sm-12">
                  <span class="manual-help activo"><a class="icons-tramite"
                      href="https://www.emvs.es/Vivienda/RPSV/Documents/Instrucciones de inscripción en el RPSV a través de la Oficina Virtual.pdf"
                      target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                        title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                </div>
              </div>
              <div class="w-100 mt-3">
                <p><strong>{{ 'TRAMITE.CONTENT.EL_APARTADO_A_Y_B_SON_EXCLUYENTES_ENTRE_SI_DANDOSE_PREFERENCIA_AL_APARTADO_A_EN_' | translate }}</strong></p>
              </div>
              <div>
                <div class="border mt-3 pl-4 pt-2">
                  <div class="row">
                    <div class="w-100 d-flex">
                      <div class="w-25">
                        <label class="font-weight-bold">{{ 'TRAMITE.FORM.LABEL.A_TODAS_LAS_ZONAS' | translate }}</label>
                      </div>
                      <div class="w-25 form-check">
                        <input class="form-check-input position-static" type="checkbox" formControlName="todas_zonas"
                          [value]="" />
                      </div>
                    </div>
                    <div class="w-100">
                      <p class="w=100">{{ 'TRAMITE.CONTENT.SE_SELECCIONARA_UNA_VIVIENDA_EN_CUALQUIER_DISTRITO_DONDE_EXISTAN_VIVIENDAS_DISPO' | translate }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="border mt-3 p-3">
                <label class="font-weight-bold">{{ 'TRAMITE.FORM.LABEL.B_CON_SELECCION_DE_ZONA' | translate }}</label>

                <div class="w-100">
                  <p class="w=100">{{ 'TRAMITE.CONTENT.ENUMERAR_POR_ORDEN_DE_PREFERENCIA_LA_ELECCION_HA_DE_SER_EXCLUSIVAMENTE_NUMERICA_' | translate }}</p>
                </div>
                <div class="row mt-2">
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.1_CENTRO' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="centro" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.8_FUENCARRAL_EL_PARDO' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="fuencarral_pardo" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.15_CIUDAD_LINEAL' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="ciudad_lineal" class="form-control" mask="9{2}">
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.2_ARGANZUELA' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="arganzuela" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.9_MONCLOA' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="moncloa" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.16_HORTALEZA' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="hortaleza" class="form-control" mask="9{2}">
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.3_RETIRO' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="retiro" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.10_LATINA' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="latina" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.17_VILLAVERDE' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="villaverde" class="form-control" mask="9{2}">
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.4_SALAMANCA' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="salamanca" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.11_CARABANCHEL' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="carabanchel" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.18_VALLECAS_VILLA' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="vallecas_villa" class="form-control" mask="9{2}">
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.5_CHAMARTIN' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="chamartin" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.12_USERA' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="usera" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.19_VICALVARO' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="vilcalvaro" class="form-control" mask="9{2}">
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.6_TETUAN' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="tetuan" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.13_PUENTE_DE_VALLECAS' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="puente_vallecas" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.20_SAN_BLAS' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="san_blas" class="form-control" mask="9{2}">
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.7_CHAMBERI' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="chamberi" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-3 col-form-label">{{ 'TRAMITE.FORM.LABEL.14_MORATALAZ' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="moratalaz" class="form-control" mask="9{2}">
                  </div>
                  <label class="col-sm-2 col-form-label">{{ 'TRAMITE.FORM.LABEL.21_BARAJAS' | translate }}</label>
                  <div class="col-sm-1">
                    <input [attr.disabled]="this.formDistritos.controls['todas_zonas']?.value == true ? 'true' : null"
                      type="text" formControlName="barajas" class="form-control" mask="9{2}">
                  </div>
                </div>
              </div>

              <div class="col-sm-12 pt-2">
                <div class="form-group">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>
                    <button type="submit" class="btn btn-primary  mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="vulnerabilidad" role="tabpanel" aria-labelledby="vulnerabilidad-tab">
            <form [formGroup]="formVulnerabilidad" (ngSubmit)="onSubmitVulnerabilidad()">
              <h3 class="tabtitle">ANEXO 1 SITUACIÓN VULNERABILIDAD RESIDENCIAL</h3>
              <div class="row mt-3">
                <div class="col-sm-12">
                  <span class="manual-help activo"><a class="icons-tramite"
                      href="https://www.emvs.es/Vivienda/RPSV/Documents/Instrucciones de inscripción en el RPSV a través de la Oficina Virtual.pdf"
                      target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                        title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                </div>
              </div>
              <div class="w-100 mt-3 font-weight-bold">
                <p>{{ 'TRAMITE.CONTENT.TODAS_LAS_CIRCUNSTANCIAS_MANIFESTADAS_PODRAN_SER_VALORADAS_POR_TECNICOS_DE_EMVS_' | translate }}</p>
              </div>
              <div class="row">
                <div class="col-sm-12 font-weight-bold">
                  <label>{{ 'TRAMITE.FORM.LABEL.1_EN_QUE_TIPO_DE_ALOJAMIENTO_RESIDE' | translate }}</label>
                </div>
                <div class="ml-3 form-check">
                  <div class="form-check">
                    <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1"
                      name="pregunta1" id="inlineRadioPregunta0A"
                      value="A. Piso, Casa, Pensión, Hostal, habitación en vivienda compartida">
                    <label class="form-check-label" for="inlineRadioPregunta0A">{{ 'TRAMITE.FORM.LABEL.PISO_CASA_PENSION_HOSTAL_HABITACION_EN_VIVIENDA_COMPARTIDA' | translate }}</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1"
                      name="pregunta1" id="inlineRadioPregunta0B"
                      value="B. Otros alojamientos: Chabola, Caravana, Local">
                    <label class="form-check-label" for="inlineRadioPregunta0B">{{ 'TRAMITE.FORM.LABEL.OTROS_ALOJAMIENTOS_CHABOLA_CARAVANA_LOCAL' | translate }}</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1"
                      name="pregunta1" id="inlineRadioPregunta0C"
                      value="C. Alojamiento institucional: recurso temporal">
                    <label class="form-check-label" for="inlineRadioPregunta0C">{{ 'TRAMITE.FORM.LABEL.ALOJAMIENTO_INSTITUCIONAL_RECURSO_TEMPORAL' | translate }}</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1"
                      name="pregunta1" id="inlineRadioPregunta0D" value="D. En la calle o albergue de forma ocasional">
                    <label class="form-check-label" for="inlineRadioPregunta0D">{{ 'TRAMITE.FORM.LABEL.EN_LA_CALLE_O_ALBERGUE_DE_FORMA_OCASIONAL' | translate }}</label>
                  </div>
                </div>
              </div>

              <div class="row mt-5">
                <div class="col-sm-12 font-weight-bold">
                  <label>{{ 'TRAMITE.FORM.LABEL.2_LA_SITUACION_DE_LA_VIVIENDA_DONDE_RESIDE' | translate }}</label>
                </div>
                <div class="ml-3">
                  <div class="form-check w-100">
                    <label>{{ 'TRAMITE.FORM.LABEL.TIENE_TITULO_SOBRE_LA_VIVIENDA' | translate }}</label>
                    <div class="ml-3">
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2"
                          name="pregunta2" id="inlineRadioPregunta0A1" value="A1. Contrato de alquiler a su nombre">
                        <label class="form-check-label" for="inlineRadioPregunta0A1">{{ 'TRAMITE.FORM.LABEL.CONTRATO_DE_ALQUILER_A_SU_NOMBRE' | translate }}</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2"
                          name="pregunta2" id="inlineRadioPregunta0A2" value="A2. Título de propiedad a su nombre">
                        <label class="form-check-label" for="inlineRadioPregunta0A2">{{ 'TRAMITE.FORM.LABEL.TITULO_DE_PROPIEDAD_A_SU_NOMBRE' | translate }}</label>
                      </div>
                    </div>
                    <label class="mt-3">{{ 'TRAMITE.FORM.LABEL.NO_TIENE_TITULO_SOBRE_LA_VIVIENDA' | translate }}</label>
                    <div class="ml-3">
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2"
                          name="pregunta2" id="inlineRadioPregunta0B1"
                          value="B1. Acogimiento temporal por familiares o amistades">
                        <label class="form-check-label" for="inlineRadioPregunta0B1">{{ 'TRAMITE.FORM.LABEL.ACOGIMIENTO_TEMPORAL_POR_FAMILIARES_O_AMISTADES' | translate }}</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2"
                          name="pregunta2" id="inlineRadioPregunta0B2" value="B2. Subarriendo o Habitación alquilada">
                        <label class="form-check-label" for="inlineRadioPregunta0B2">{{ 'TRAMITE.FORM.LABEL.SUBARRIENDO_O_HABITACION_ALQUILADA' | translate }}</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2"
                          name="pregunta2" id="inlineRadioPregunta0B3" value="B3. Ocupación">
                        <label class="form-check-label" for="inlineRadioPregunta0B3">{{ 'TRAMITE.FORM.LABEL.OCUPACION' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-5">
                <div class="col-sm-12 font-weight-bold">
                  <label>{{ 'TRAMITE.FORM.LABEL.3_LA_VIVIENDA_DONDE_RESIDE_TIENE_PROBLEMAS_DE_ACCESIBILIDAD_O_IMPEDIMENTOS_FISIC' | translate }}</label>
                </div>
                <div class="ml-3 form-check">
                  <div class="w-100">
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta3"
                        name="pregunta3" id="inlineRadioPregunta3A" value="A. No existen problemas de accesibilidad">
                      <label class="form-check-label" for="inlineRadioPregunta3A">{{ 'TRAMITE.FORM.LABEL.NO_EXISTEN_PROBLEMAS_DE_ACCESIBILIDAD' | translate }}</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta3"
                        name="pregunta3" id="inlineRadioPregunta3B"
                        value="B. Existe algún problema o impedimento físico, pudiendo mantener su autonomía">
                      <label class="form-check-label" for="inlineRadioPregunta3B">{{ 'TRAMITE.FORM.LABEL.EXISTE_ALGUN_PROBLEMA_O_IMPEDIMENTO_FISICO_PUDIENDO_MANTENER_SU_AUTONOMIA' | translate }}</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta3"
                        name="pregunta3" id="inlineRadioPregunta3C"
                        value="C. Existen importantes impedimentos o barreras arquitectónicas que impiden mantener su autonomía">
                      <label class="form-check-label" for="inlineRadioPregunta3C">{{ 'TRAMITE.FORM.LABEL.EXISTEN_IMPORTANTES_IMPEDIMENTOS_O_BARRERAS_ARQUITECTONICAS_QUE_IMPIDEN_MANTENER' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-5">
                <div class="col-sm-12 font-weight-bold">
                  <label>{{ 'TRAMITE.FORM.LABEL.4_LA_VIVIENDA_DONDE_RESIDE_SE_ENCUENTRA_EN_SITUACION_DE_RIESGO_DE_PERDERLA' | translate }}</label>
                </div>
                <div class="ml-3">
                  <div class="form-check w-100">
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4"
                        name="pregunta4" id="inlineRadioPregunta4A" value="A. NO">
                      <label class="form-check-label" for="inlineRadioPregunta4A">{{ 'TRAMITE.CONTENT.NO' | translate }}</label>
                    </div>
                    <label class="mt-3">{{ 'TRAMITE.CONTENT.SI' | translate }}</label>
                    <div class="ml-3">
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4"
                          name="pregunta4" id="inlineRadioPregunta4B1"
                          value="B1. Notificación legal de abandono de vivienda">
                        <label class="form-check-label" for="inlineRadioPregunta4B1">{{ 'TRAMITE.FORM.LABEL.NOTIFICACION_DE_LA_FINALIZACION_DEL_CONTRATO_POR_PARTE_DEL_PROPIETARIO_DE_LA_VIV' | translate }}</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4"
                          name="pregunta4" id="inlineRadioPregunta4B2" value="B2. Procedimiento de desahucio vigente contra el solicitante o
                        miembros de la unidad familiar incluidos en la solicitud">
                        <label class="form-check-label" for="inlineRadioPregunta4B2">{{ 'TRAMITE.FORM.LABEL.PROCEDIMIENTO_DE_DESAHUCIO_VIGENTE_CONTRA_EL_SOLICITANTE_O_MIEMBROS_DE_LA_UNIDAD' | translate }}</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4"
                          name="pregunta4" id="inlineRadioPregunta4B3" value="B3. Por encontrarse viviendo bajo una situación de violencia en el
                        domicilio">
                        <label class="form-check-label" for="inlineRadioPregunta4B3">{{ 'TRAMITE.FORM.LABEL.POR_ENCONTRARSE_VIVIENDO_BAJO_UNA_SITUACION_DE_VIOLENCIA_EN_EL_DOMICILIO_EXCLUID' | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-5">
                <div class="col-sm-12 font-weight-bold">
                  <label>{{ 'TRAMITE.FORM.LABEL.5_LA_VIVIENDA_DONDE_RESIDE_POR_LAS_DIMENSIONES_DE_LA_MISMA_ES_ADECUADA_PARA_SU_U' | translate }}</label>
                </div>
                <div class="ml-3">
                  <div class="form-check w-100">
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta5"
                        name="pregunta5" id="inlineRadioPregunta5A"
                        value="A. Sí, el espacio es suficiente (1 persona por habitación)">
                      <label class="form-check-label" for="inlineRadioPregunta5A">{{ 'TRAMITE.FORM.LABEL.SI_EL_ESPACIO_ES_SUFICIENTE_1_PERSONA_POR_HABITACION' | translate }}</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta5"
                        name="pregunta5" id="inlineRadioPregunta5B"
                        value="B. Existen algunas dificultades de espacio (2 personas por habitación)">
                      <label class="form-check-label" for="inlineRadioPregunta5B">{{ 'TRAMITE.FORM.LABEL.EXISTEN_ALGUNAS_DIFICULTADES_DE_ESPACIO_2_PERSONAS_POR_HABITACION' | translate }}</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta5"
                        name="pregunta5" id="inlineRadioPregunta5C"
                        value="C. Existe hacinamiento grave (3 o más personas por habitación)">
                      <label class="form-check-label" for="inlineRadioPregunta5C">{{ 'TRAMITE.FORM.LABEL.EXISTE_HACINAMIENTO_GRAVE_3_O_MAS_PERSONAS_POR_HABITACION' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-5">
                <div class="col-sm-12 font-weight-bold">
                  <label>{{ 'TRAMITE.FORM.LABEL.6_LA_VIVIENDA_DONDE_RESIDE_SE_ENCUENTRA_EN_ADECUADAS_CONDICIONES_DE_HABITABILIDA' | translate }}</label>
                </div>
                <div class="ml-3">
                  <div class="form-check w-100">
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta6"
                        name="pregunta6" id="inlineRadioPregunta6A"
                        value="A. Sí, las condiciones de habitabilidad son adecuadas">
                      <label class="form-check-label" for="inlineRadioPregunta6A">{{ 'TRAMITE.FORM.LABEL.SI_LAS_CONDICIONES_DE_HABITABILIDAD_SON_ADECUADAS' | translate }}</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta6"
                        name="pregunta6" id="inlineRadioPregunta6B" value="B. Tiene una situación de cierto deterioro en cuanto al estado general
                      de la vivienda sin afectar a suministros básicos">
                      <label class="form-check-label" for="inlineRadioPregunta6B">{{ 'TRAMITE.FORM.LABEL.TIENE_UNA_SITUACION_DE_CIERTO_DETERIORO_EN_CUANTO_AL_ESTADO_GENERAL_DE_LA_VIVIEN' | translate }}</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta6"
                        name="pregunta6" id="inlineRadioPregunta6C" value="C. La vivienda se encuentra inhabitable: ausencia de los suministros
                      básicos y/o deterioro de la misma en cuanto a
                      cerramiento, ventilación y estado general">
                      <label class="form-check-label" for="inlineRadioPregunta6C">{{ 'TRAMITE.FORM.LABEL.LA_VIVIENDA_SE_ENCUENTRA_INHABITABLE_AUSENCIA_DE_LOS_SUMINISTROS_BASICOS_Y_O_DET' | translate }}</label>
                    </div>

                  </div>
                </div>
              </div>
              <div class="col-sm-12 pt-2">
                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                  <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                  <button type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>
                  <button type="submit" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                </div>
              </div>
            </form>
          </div>

          <div class="tab-pane fade" id="autorizacion" role="tabpanel" aria-labelledby="autorizacion-tab">
            <form [formGroup]="formAutorizacion" (ngSubmit)="onSubmitAutorizacionCheck()">
              <h3 class="tabtitle">{{ 'TRAMITE.TITLES.DATA_AUTHORIZATION_PUBLIC' | translate }}</h3>
              <div class="row mt-3">
                <div class="col-sm-12">
                  <span class="manual-help activo"><a class="icons-tramite"
                      href="https://www.emvs.es/Vivienda/RPSV/Documents/Instrucciones de inscripción en el RPSV a través de la Oficina Virtual.pdf"
                      target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                        title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                </div>
              </div>

              <div formArrayName="autorizacion">
                <div class="familiar-accordion familiar-accordion--readonly"
                  *ngIf="lastVisitedTab == 'autorizacion-tab'">
                  <ng-container *ngFor="let passengerGroup of autorizacion?.controls; let i = index">
                    <div class="familiar-card"
                      *ngIf="passengerGroup.get('fecha_nacimiento')?.value ? esMayorEdad(passengerGroup.get('fecha_nacimiento').value) : false"
                      [class.is-active]="autorizacionActivo === i" [formGroupName]="i">
                      <button type="button" class="familiar-card__header" (click)="toggleAutorizacion(i)"
                        [attr.aria-expanded]="autorizacionActivo === i">
                        <span class="familiar-card__index">{{ i + 1 }}</span>
                        <span class="familiar-card__summary">
                          <strong>{{ (passengerGroup.get('nombre')?.value + ' ' +
                            (passengerGroup.get('primerApellido')?.value || '')).trim() || 'Sin nombre' }}</strong>
                          <small>
                            <ng-container *ngIf="passengerGroup.get('parentesco')?.value">{{
                              passengerGroup.get('parentesco')?.value }}</ng-container>
                            <ng-container
                              *ngIf="passengerGroup.get('parentesco')?.value && passengerGroup.get('documento')?.value">
                              · </ng-container>
                            <ng-container *ngIf="passengerGroup.get('documento')?.value">{{
                              passengerGroup.get('documento')?.value }}</ng-container>
                          </small>
                        </span>
                        <span class="familiar-card__check"
                          [class.is-checked]="passengerGroup.get('send_request_accept')?.value">
                          <ng-container *ngIf="passengerGroup.get('send_request_accept')?.value">✓
                            Autorizado</ng-container>
                          <ng-container *ngIf="!passengerGroup.get('send_request_accept')?.value">Sin
                            autorizar</ng-container>
                        </span>
                        <span class="familiar-card__chevron" aria-hidden="true">▾</span>
                      </button>
                      <div class="familiar-card__body" *ngIf="autorizacionActivo === i">
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'TRAMITE.FORM.LABEL.DNI_NIE' | translate }}</label>
                          <span class="familiar-field__value">{{ passengerGroup.get('documento')?.value || '—' }}</span>
                        </div>
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'PROCEDIMIENTO.EDIT.NAME' | translate }}</label>
                          <span class="familiar-field__value">{{ passengerGroup.get('nombre')?.value || '—' }}</span>
                        </div>
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'TRAMITE.FORM.LABEL.APELLIDO_1' | translate }}</label>
                          <span class="familiar-field__value">{{ passengerGroup.get('primerApellido')?.value || '—'
                            }}</span>
                        </div>
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'TRAMITE.FORM.LABEL.APELLIDO_2' | translate }}</label>
                          <span class="familiar-field__value">{{ passengerGroup.get('segundoApellido')?.value || '—'
                            }}</span>
                        </div>
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'TRAMITE.FORM.LABEL.FECHA_DE_NACIMIENTO' | translate }}</label>
                          <span class="familiar-field__value">{{ (passengerGroup.get('fecha_nacimiento')?.value |
                            date:'dd/MM/yyyy') || '—' }}</span>
                        </div>
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'TRAMITE.FORM.LABEL.ESTADO_CIVIL' | translate }}</label>
                          <span class="familiar-field__value">{{ passengerGroup.get('estado_civil')?.value || '—'
                            }}</span>
                        </div>
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'TRAMITE.FORM.LABEL.PARENTESCO' | translate }}</label>
                          <span class="familiar-field__value">{{ passengerGroup.get('parentesco')?.value || '—'
                            }}</span>
                        </div>
                        <label class="familiar-field__checkbox">
                          <input type="checkbox" formControlName="send_request_accept">
                          <span>{{ 'TRAMITE.TEXT.AUTHORIZE_QUERY' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="row  p-2" style="margin-top: 25px;">
                <p class="smallInfo font1rem">Esta autorización deberá ir <strong>{{ 'TRAMITE.CONTENT.FIRMADA_POR_TODOS_LOS_MAYORES_DE_18_ANOS' | translate }}</strong>: Tras el envío firmado de este trámite por usted como solicitante, el resto de
                  personas tendrán una notificación en la Oficina Virtual que podrán firmar digitalmente a través de sus
                  propias cuentas de usuario (deberán registrarse en la oficina si no lo han hecho previamente).</p>
                <p class="smallInfo font1rem"> <strong>{{ 'TRAMITE.CONTENT.LA_PRESENTE_SOLICITUD_DE_INSCRIPCION_EN_EL_REGISTRO_PERMANENTE_DE_SOLICITANTES_N' | translate }}</strong></p>
                <p class="smallInfo font1rem"><strong>{{ 'TRAMITE.CONTENT.EN_CASO_DE_NO_AUTORIZAR_A_EMVS_MADRID_PARA_REALIZAR_LA_CONSULTA_DE_DATOS_USTED_D' | translate }}</strong> Los
                  interesados serán responsables de la veracidad de los datos y documentos que presentan, bajo las
                  posibles acciones que se pudieran iniciar en caso de falsedad u ocultación de datos y/o documentos.
                </p>
              </div>
              <div class="row p-2">
                <label class="font-weight-bold w-100 "><u>SE CONSULTARÁ LA SIGUIENTE INFORMACIÓN</u></label>
                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.DNI_NIE' | translate }}</label>
                  </div>
                </div>

                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.CERTIFICADO_DEL_IRPF_O_CERTIFICADO_DE_IMPUTACIONES_Y_O_PENSIONES_PUBLICAS_EXENTA' | translate }}</label>
                  </div>
                </div>

                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.PRESTACIONES_SOCIALES_PUBLICAS_INCAPACIDAD_TEMPORAL_Y_MATERNIDAD' | translate }}</label>
                  </div>
                </div>

                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.FAMILIA_NUMEROSA' | translate }}</label>
                  </div>
                </div>

                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.DISCAPACIDAD_Y_O_DEPENDENCIA' | translate }}</label>
                  </div>
                </div>

                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.TITULARIDAD_INMUEBLES_Y_O_NOTA_SIMPLE' | translate }}</label>
                  </div>
                </div>

                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.EMPADRONAMIENTO' | translate }}</label>
                  </div>
                </div>
              </div>
              <div class="row  p-2">
                <label class="font-weight-bold w-100 "><u>Cláusula de Privacidad</u></label>
                <p class="smallInfo">
                  De conformidad con el Reglamento (UE) 2016/679 de 27 de abril de 2016, relativo a la protección de las
                  personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de
                  estos datos, y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía
                  de los derechos digitales, la EMVS, como responsable de sus datos personales, le informa que los datos
                  serán recabados con la finalidad de consultar sus datos personales con las administraciones y
                  organismos públicos correspondientes, en el marco de la gestión del tratamiento. La base jurídica que
                  legitima el tratamiento es el consentimiento de la persona interesada.

                  <br />La EMVS podrá comunicar sus datos personales a administraciones y organismos públicos
                  competentes para la gestión del tratamiento. No se realizarán transferencias internacionales ni se
                  adoptarán decisiones basadas únicamente en el tratamiento automatizado de los datos personales.

                  <br />Los datos personales solicitados para esta actividad serán conservados durante el tiempo
                  necesario para gestionar la finalidad para la que han sido recabados y, en todo caso, hasta que hayan
                  prescrito los plazos para interponer cualquier acción civil, penal o administrativa relacionada con el
                  tratamiento.

                  <br />En cualquier momento, el titular podrá ejercer sus derechos de acceso, rectificación, supresión,
                  limitación, portabilidad u oposición, personándose en nuestras oficinas o dirigiéndose por escrito a
                  la EMVS, ya sea por correo postal, a través del Portal de la Oficina Virtual (<a
                    class="icons-tramite font-weight-bold" href="https://oficinavirtual.emvs.es/#/"
                    target="_blank">https://oficinavirtual.emvs.es/#/</a>), o mediante correo electrónico a
                  proteccion.datos&#64;emvs.es, debiendo acreditar su identidad con el correspondiente documento
                  acreditativo.

                  <br />También podrá contactar con el Delegado de Protección de Datos a través del correo electrónico
                  dpd&#64;emvs.es. En caso de no obtener la respuesta deseada, podrá presentar una reclamación ante la
                  Agencia Española de Protección de Datos (AEPD) en www.aepd.es

                  <br />La información ampliada sobre protección de datos está disponible en el siguiente enlace: <a
                    class="icons-tramite font-weight-bold"
                    href="https://www.emvs.es/terminos-y-condiciones/autorizacion-de-consulta"
                    target="_blank">https://www.emvs.es/terminos-y-condiciones/autorizacion-de-consulta</a>
                </p>
              </div>
              <div class="col-sm-12">
                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                  <button type="button" [disabled]="uploadDocuments" class="btn btn-danger mt-2 mr-2"
                    (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                  <button type="button" [disabled]="uploadDocuments" class="btn btn-primary mt-2 mr-2"
                    (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>
                  <fieldset>
                    <boton-listado>
                    </boton-listado>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="consulta" role="tabpanel" aria-labelledby="consulta-tab">
            <form [formGroup]="formDeclaracionResponsable" (ngSubmit)="onSubmitConsulta()">
              <h3 class="tabtitle">{{ 'TRAMITE.TITLES.RESPONSIBLE_DECLARATION' | translate }}</h3>
              <div class="col-sm-12 p-2">
                <p>En calidad de solicitante <strong>{{ 'TRAMITE.CONTENT.DECLARO_BAJO_MI_RESPONSABILIDAD' | translate }}</strong>,
                  que todas las personas de la unidad familiar solicitante reúnen los requisitos exigidos para
                  el acceso al Registro Permanente de Solicitantes de Vivienda, establecidos en el vigente Reglamento,
                  garantizando asimismo la veracidad de los datos expresados en la solicitud, disponiendo de la
                  documentación
                  que así lo acredita, relacionada a continuación, con carácter meramente enunciativo, que la pondré a
                  disposición de EMVS Madrid cuando me sea requerida y que me comprometo a mantener el cumplimiento de
                  las anteriores obligaciones durante el periodo de vigencia de dicha inscripción.</p>
              </div>
              <div class="col-sm-12">
                <div class="row">
                  <table class="table-rpsv table-bordered table-striped table-hover align-middle">
                    <tbody>
                      <tr>
                        <td colspan="2">{{ 'TRAMITE.CONTENT.DNI_NIE_CERTIFICADO_DE_REGISTRO_DE_CIUDADANO_DE_LA_UE_CON_DOCUMENTO_IDENTIFICATI' | translate }}</td>
                      </tr>
                      <tr>
                        <td colspan="2">{{ 'TRAMITE.CONTENT.LIBRO_DE_FAMILIA_EN_SU_DEFECTO_CERTIFICADO_DE_MATRIMONIO_CERTIFICADO_DE_NACIMIEN' | translate }}</td>
                      </tr>
                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.PERSONA_SEPARADA_O_DIVORCIADA' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.TESTIMONIO_JUDICIAL_DE_SENTENCIA_FIRME_DE_SEPARACION_O_DIVORCIO' | translate }}</li>
                            <li>{{ 'TRAMITE.CONTENT.TESTIMONIO_JUDICIAL_DEL_CONVENIO_REGULADOR_SI_PROCEDE' | translate }}</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.PERSONA_VIUDA' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.LIBRO_DE_FAMILIA_O_CERTIFICADO_DE_MATRIMONIO' | translate }}</li>
                            <li>{{ 'TRAMITE.CONTENT.CERTIFICADO_DE_DEFUNCION' | translate }}</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.FAMILIA_MONOPARENTAL' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.TESTIMONIO_JUDICIAL_DE_SENTENCIA_FIRME_DE_OSTENTAR_LA_GUARDA_Y_CUSTODIA_EXCLUSIV' | translate }}</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.SI_NO_SE_ACREDITA_1_ANO_DE_EMPADRONAMIENTO_EN_EL_MUNICIPIO_DE_MADRID_PERO_SI_2_A' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.CERTIFICADO_DE_VIDA_LABORAL_ACTUAL' | translate }}</li>
                            <li>{{ 'TRAMITE.CONTENT.CERTIFICADO_DE_EMPRESA_QUE_ACREDITE_ANTIGUEDAD_MINIMA_DE_2_ANOS_DOMICILIO_Y_CODI' | translate }}</li>
                            <li>{{ 'TRAMITE.CONTENT.DECLARACION_CENSAL_TRABAJADOR_POR_CUENTA_PROPIA' | translate }}</li>
                            <li>{{ 'TRAMITE.CONTENT.NOMBRAMIENTO_COMO_PERSONAL_FUNCIONARIO_EN_ADMINISTRACION_PUBLICA_QUE_ACREDITE_AN' | translate }}</li>
                            <li>{{ 'TRAMITE.CONTENT.RESOLUCION_DEL_SEPE_EN_CASO_DE_HABER_TRAMITADO_SUBSIDIO_POR_DESEMPLEO_EN_OFICINA' | translate }}</li>
                          </ul>
                        </td>

                      </tr>

                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.SI_LA_UNIDAD_FAMILIAR_ESTA_COMPUESTA_POR_CONYUGE_Y_O_HIJOS_MAYORES_DE_EDAD_O_Y_O' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.CERTIFICADO_DE_EMPADRONAMIENTO_FAMILIAR' | translate }}</li>
                          </ul>

                        </td>
                      </tr>

                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.MOVILIDAD_REDUCIDA' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.CERTIFICADO_DE_NECESIDAD_DE_VIVIENDA_ADAPTADA_EMITIDO_POR_EL_CENTRO_BASE_CORRESP' | translate }}</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.VICTIMA_DE_VIOLENCIA_DE_GENERO' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.ORDEN_DE_PROTECCION_O_SENTENCIA_CONDENATORIA_O_TITULO_HABILITANTE' | translate }}</li>
                          </ul>

                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.PARA_CIUDADANOS_EXTRANJEROS_DE_PAISES_MIEMBROS_DE_LA_UE' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.DOCUMENTACION_ORIGINAL_Y_LA_TRADUCCION_JURADA_DE_LA_MISMA' | translate }}</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.PARA_EL_RESTO_DE_CIUDADANOS_EXTRANJEROS' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.DOCUMENTACION_ORIGINAL_LEGALIZADA_EN_EL_IDIOMA_DE_ORIGEN_ASI_COMO_LA_TRADUCCION_' | translate }}</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.ALOJAMIENTO_INSTITUCIONAL' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.CERTIFICADO_DEL_RECURSO_EN_EL_QUE_RESIDE' | translate }}</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.NOTIFICACION_DE_LA_FINALIZACION_DEL_CONTRATO_POR_PARTE_DEL_PROPIETARIO_DE_LA_VIV' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.COPIA_CONTRATO_DE_ARRENDAMIENTO_Y_NOTIFICACION_LEGAL_DE_ABANDONO_DE_VIVIENDA' | translate }}</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.PROCEDIMIENTO_DE_DESAHUCIO_VIGENTE' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.DOCUMENTO_JUDICIAL_QUE_ACREDITE_EL_PROCEDIMIENTO_LEGAL_DE_DESAHUCIO_EN_VIGOR' | translate }}</li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ 'TRAMITE.CONTENT.VIOLENCIA_EN_EL_DOMICILIO_EXCLUIDAS_VICTIMAS_DE_VIOLENCIA_DE_GENERO' | translate }}</td>
                        <td>
                          <ul class="mb-0">
                            <li>{{ 'TRAMITE.CONTENT.SENTENCIA_DENUNCIA_O_INFORMES_JUSTIFICATIVOS_DE_TAL_CIRCUNSTANCIA' | translate }}</li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-sm-12 mt-2">
                <div class="row">
                  <p class="font-weight-bold">{{ 'TRAMITE.CONTENT.CONOZCO_QUE_LA_INEXACTITUD_FALSEDAD_U_OMISION_DE_CARACTER_ESENCIAL_DE_CUALQUIER_' | translate }}</p>
                  <label class="font-weight-bold w-100 mt-2"><u>Cláusula de Privacidad</u></label>
                  <p>De conformidad con el Reglamento (UE) 2016/679, de 27 de abril, y la Ley Orgánica 3/2018, de 5 de
                    diciembre, la Empresa Municipal de la Vivienda y Suelo de Madrid, S.A. (EMVS), como responsable del
                    tratamiento, le informa de que los datos personales facilitados serán tratados con la finalidad de
                    gestionar su solicitud de inscripción en el Registro Permanente de Solicitantes de Vivienda (RPSV),
                    verificar el cumplimiento de los requisitos exigidos, y realizar, en su caso, la adjudicación de
                    viviendas en régimen de arrendamiento gestionadas por la EMVS. La base legitimadora del tratamiento
                    es el consentimiento de la persona interesada y el cumplimiento de una misión realizada en interés
                    público.

                    <br />La EMVS podrá ceder sus datos personales a otras administraciones públicas, organismos
                    competentes o terceros autorizados cuando sea necesario para la tramitación y gestión de su
                    solicitud. No se realizarán transferencias internacionales, ni se adoptarán decisiones basadas
                    únicamente en el tratamiento automatizado de los datos personales de sus usuarios.

                    <br />Los datos personales se conservarán durante el tiempo necesario para gestionar y tramitar su
                    solicitud. En caso de desestimación, los datos se suprimirán una vez finalizada la tramitación. Si
                    cumple los requisitos y se inscribe en el Registro Permanente de Solicitantes de Vivienda, sus datos
                    se conservarán durante cuatro años desde la última actualización de la inscripción, conforme al
                    artículo 9 del Reglamento de Adjudicación de Viviendas vigente. Si resulta adjudicatario, sus datos
                    dejarán de formar parte del Registro a partir de la firma del contrato. En todo caso, los datos
                    podrán conservarse hasta que hayan prescrito los plazos para interponer acciones legales,
                    administrativas o contractuales relacionadas con el tratamiento.

                    <br />En cualquier momento, la persona interesada puede ejercer sus derechos de acceso,
                    rectificación, supresión, oposición, limitación del tratamiento y portabilidad, presentándose en
                    nuestras oficinas o mediante escrito dirigido a la EMVS, ya sea por correo postal, a través del
                    Portal de la Oficina Virtual (<a class="icons-tramite font-weight-bold"
                      href="https://oficinavirtual.emvs.es/#/" target="_blank">https://oficinavirtual.emvs.es/#/</a>), o
                    mediante correo electrónico a proteccion.datos&#64;emvs.es, acreditando debidamente su identidad.

                    <br />Puede contactar con el Delegado de Protección de Datos a través del correo electrónico
                    dpd&#64;emvs.es. Asimismo, si considera que sus derechos no han sido debidamente atendidos, puede
                    presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD) en www.aepd.es

                    <br />La información ampliada sobre protección de datos está disponible en el siguiente enlace: <a
                      class="icons-tramite font-weight-bold"
                      href="https://www.emvs.es/terminos-y-condiciones/inscripcion-RPSV"
                      target="_blank">https://www.emvs.es/terminos-y-condiciones/inscripcion-RPSV</a>
                  </p>
                </div>
                <div class="pl-3 row">
                  <label class="form-check-label font-weight-bold"><input class="form-check-input position-static"
                      type="checkbox" formControlName="declaracion" id="declaracion" [value]="" />
                    He leído y acepto</label>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="d-grid gap-2 d-md-flex justify-content-md-end row">
                  <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                  <button type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>
                  <button type="submit" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
  <form id="firma" (submit)="resultchange($event)" class="">
    <input type="hidden" id="result" />
    <input type="hidden" id="error" />
    <input type="hidden" id="certifcado" />
  </form>

  <div class="modal fade show" id="modalAvisoFirmas" tabindex="-1" aria-labelledby="modalAvisoFirmasLabel"
    aria-hidden="true" [ngStyle]="{'display':displayAvisoFirma}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5>{{ 'CONFIRM_EMAIL.WARNING.TITLE' | translate }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="displayAvisoFirma='none'">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h6>¿Está seguro de que no desea autorizar la consulta de datos de las personas mayores de 18 años incluidas
            en la unidad familiar?</h6>
          <br />
          <p>De no hacerlo usted deberá aportar toda la documentación necesaria a través de instancia general en <a
              class="icons-tramite font-weight-bold" href="https://oficinavirtual.emvs.es/#/"
              target="_blank">https://oficinavirtual.emvs.es/#/;</a> o de manera presencial en nuestras oficinas en C/
            Palos de la Frontera 13, de lunes a viernes de 8:30 a 14:00 h, mediante cita previa.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary mt-2 mr-2" (click)="closeAvisoFirmaModal()">{{ 'TRAMITE.CONTENT.VOLVER_AL_TRAMITE' | translate }}</button>
          <button type="button" class="btn btn-secondary-b mt-2 mr-2" (click)="onSubmitAutorizacion()">{{ 'TRAMITE.CONTENT.CONTINUAR_CON_LA_FIRMA' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>